export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10726.5ae8d141.jpg";